import { render, staticRenderFns } from "./FormStoreGiftListComponent.vue?vue&type=template&id=d8bf0770&scoped=true&"
import script from "./FormStoreGiftListComponent.vue?vue&type=script&lang=js&"
export * from "./FormStoreGiftListComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormStoreGiftListComponent.vue?vue&type=style&index=0&id=d8bf0770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bf0770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VForm,VIcon,VRow,VSwitch,VTextField,VTextarea})
